import { ICollectionPoint } from "./CollectionPointEntity";

interface IFormData {
    pickup_now_enabled: boolean;
    pickup_now_auto_close_orders_enabled: boolean;
    min_pickup_now_price: number;
    collection_points: ICollectionPoint[];
}

export function collectionPointResolver(data: IFormData, t: any) {
    const cP = data.collection_points;
    const length = cP.length;
    const validationOutput: Record<string, any> = {};
    /**Loop through all the collection points */
    for (let i = 0; i < length; i++) {
        const obj = cP[i];
        const root = `collection_points.${i}.`;
        const keyName = `${root}name`;
        const keyMax = `${root}max_number_of_concurrent_orders`;
        /**Validate name */
        if (!obj.name || obj.name.length === 0 || startingSpace(obj.name)) {
            validationOutput[keyName] = { name: keyName, type: "validation", message: t('forms.mysettings.tableRangesNameError') }
        }

        const parsed = parseInt(obj?.max_number_of_concurrent_orders as any);
        /**Validate value */
        if (parsed <= 0 || Number.isNaN(parsed)) {
            validationOutput[keyMax] = { name: keyMax, type: "validation", message: t('forms.mysettings.tableRangesMaxError') }
        }
    }
    const hasErrors = !!Object.keys(validationOutput).length;
    return {
        values: hasErrors ? {} : data,
        errors: hasErrors ? validationOutput : {}
    };
    // }
}

function startingSpace(value: string) {
    const regex = new RegExp(/^\s/g);
    return regex.test(value);
}
